<app-header *ngIf="userService.currentUser"></app-header>

<app-sidebar *ngIf="false"></app-sidebar>

<div class="app-body full">
	<router-outlet></router-outlet>
</div>

<app-toasts></app-toasts>
